import { render, staticRenderFns } from "./SingleConfig.vue?vue&type=template&id=6ff2d2c4&"
import script from "./SingleConfig.vue?vue&type=script&lang=js&"
export * from "./SingleConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports